import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { refillColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getRefill } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "batch_id", "status", "transaction_id"];

const VerizonRefillBatch = () => (
  <BatchDetail
    title="Refill"
    apiGet={__getRefill}
    client={CLIENTS.verizon}
    columnsFactory={(ctx) => refillColumns({ ...ctx, msisdnHeaderName: "MSISDN", showTrialCount: true })}
    copyKeys={COPY_KEYS}
    exportAction="refill"
    retryOperation="refill"
    showTerminate
    getRowPath={(row) => `/verizon/refill/${row.id}`}
  />
);

export default VerizonRefillBatch;
